import type { OrderStatus } from '@/types/api';

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  PRODUCTION: 'Produção',
  PENDING: 'Pendente',
  DELIVERED: 'Entregue',
  PAID: 'Pago',
  FINISHED: 'Finalizado',
  CANCELLED: 'Cancelado',
};

export const ORDER_STATUS_BADGE_VARIANTS: Record<
  OrderStatus,
  'default' | 'success' | 'warning' | 'danger'
> = {
  PRODUCTION: 'default',
  PENDING: 'warning',
  DELIVERED: 'success',
  PAID: 'success',
  FINISHED: 'default',
  CANCELLED: 'danger',
};

export const ORDER_STATUS_FLOW: OrderStatus[] = [
  'PRODUCTION',
  'PENDING',
  'DELIVERED',
  'PAID',
  'FINISHED',
];

export const ORDER_STATUS_FILTERS: OrderStatus[] = [
  'PRODUCTION',
  'PENDING',
  'DELIVERED',
  'PAID',
  'FINISHED',
];

export const getOrderStatusLabel = (status?: string | null): string => {
  if (!status) {
    return 'Sem status';
  }
  return ORDER_STATUS_LABELS[status as OrderStatus] ?? status;
};


